export const GET_SINGLE_STORE_CONFIG = "GET_SINGLE_STORE_CONFIG";
export const GET_SINGLE_STORE_CONFIG_SUCCESS = "GET_SINGLE_STORE_CONFIG_SUCCESS";
export const GET_SINGLE_STORE_CONFIG_ERROR = "GET_SINGLE_STORE_CONFIG_ERROR";

export const GET_STORE_BY_LOCATION = "GET_STORE_BY_LOCATION";
export const GET_STORE_BY_LOCATION_SUCCESS = "GET_STORE_BY_LOCATION_SUCCESS";
export const GET_STORE_BY_LOCATION_ERROR = "GET_STORE_BY_LOCATION_ERROR";

export const GET_BRAND_LOCATIONS = "GET_BRAND_LOCATIONS";
export const GET_BRAND_LOCATIONS_SUCCESS = "GET_BRAND_LOCATIONS_SUCCESS";
export const GET_BRAND_LOCATIONS_ERROR = "GET_BRAND_LOCATIONS_ERROR";

export const SET_RESTAURANT_SLUG = "SET_RESTAURANT_SLUG";

